var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M5.46704 8.01937C5.46704 7.18348 6.09453 6.50586 6.86858 6.50586H16.8517C17.6258 6.50586 18.2533 7.18348 18.2533 8.01937V20.761C18.2533 21.1192 17.9843 21.4097 17.6526 21.4097H6.0677C5.73596 21.4097 5.46704 21.1192 5.46704 20.761V8.01937ZM6.86858 7.80316C6.758 7.80316 6.66836 7.89996 6.66836 8.01937V20.1124H17.0519V8.01937C17.0519 7.89996 16.9623 7.80316 16.8517 7.80316H6.86858Z",
  fill: "#B5BECD"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.2099 7.80315H3.5105V6.50586H20.2099V7.80315Z",
  fill: "#B5BECD"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.4502 5.05404C7.4502 4.21815 8.07768 3.54053 8.85173 3.54053H14.8686C15.6426 3.54053 16.2701 4.21815 16.2701 5.05404V7.78847H15.0688V5.05404C15.0688 4.93463 14.9792 4.83782 14.8686 4.83782H8.85173C8.74115 4.83782 8.65151 4.93463 8.65151 5.05404V7.78847H7.4502V5.05404Z",
  fill: "#B5BECD"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3529 10.3474L10.3529 17.5688L9.15161 17.5688L9.15161 10.3474L10.3529 10.3474Z",
  fill: "#B5BECD"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5685 10.3474L14.5685 17.5688L13.3672 17.5688L13.3672 10.3474L14.5685 10.3474Z",
  fill: "#B5BECD"
});

function SvgGroupTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 25,
    viewBox: "0 0 23 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupTrash);
export default __webpack_public_path__ + "static/media/GroupTrash.ee689648.svg";
export { ForwardRef as ReactComponent };